import { useDialog } from '@gyym/ui'
import { useRouter } from 'next/router'
import React from 'react'

import { useAuthUser, useResendVerificationEmail } from '@/modules/Auth'

export const useCheckResendVerificationEmail = () => {
  const { isLoggedIn, isEmailVerified } = useAuthUser()
  const { openDialog } = useDialog()
  const router = useRouter()
  const resendVerificationEmail = useResendVerificationEmail(router.asPath)

  const shouldResend = isLoggedIn && !isEmailVerified

  const open = React.useCallback(() => {
    if (!shouldResend) return

    openDialog({
      title: 'メールアドレスが未認証です',
      body: (
        <>
          メール認証が完了していません。
          <br />
          登録メールの送信から時間が経過している場合は再度登録メールを再送して認証を完了させてください。
        </>
      ),
      positiveAction: {
        label: 'メールを再送',
        onClick: resendVerificationEmail,
      },
    })
  }, [shouldResend, openDialog, resendVerificationEmail])

  return {
    shouldResendVerificationEmail: shouldResend,
    openResendVerificationDialog: open,
  }
}
